import React, { useEffect, useRef, useState } from 'react';
import styles from './../addCategoryForm/addCategoryForm.module.css';
import { useParams } from 'react-router-dom';
import api from '../../utils/api';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminDetailsThunk } from '../../redux/admin/adminSlice';


const ViewAdminForm = () => {


    const {adminDetails,loading} = useSelector((state)=>state.admin)
    const admin = adminDetails?.admin
    const customers = adminDetails?.customer
    
    const { id } = useParams()

     const dispatch = useDispatch();
    
      useEffect(() => {
        dispatch(getAdminDetailsThunk(id))
      }, []);

   

    return (
        <>
            {loading ? <div>Loading...</div> :
                <div className={styles.updateCategoryContainer}>
                    <div className={styles.genaralInfo}>
                        <div className={styles.formSection}>
                            <div className={styles.card}>
                                <h2 className={styles.addCatH2}>General Information</h2>

                                <label className={styles.addCatLabel} >
                                    Full name
                                    <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center' }}>{admin?.name}</div>
                                </label>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Phone number
                                        <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>{admin?.phone}</div>


                                    </label>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Email id
                                        <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>{admin?.email}</div>
                                    </label>
                                </div>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Password
                                        <div className={styles.logininputContainer}>
                                            <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                                                {admin?.password}</div>

                                        </div>

                                    </label>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Confirm password
                                        <div className={styles.logininputContainer}>
                                            <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center' }}> {admin?.password}</div>

                                        </div>

                                    </label>

                                </div>

                            </div>
                            <div className={styles.card}>
                                <h2 className={styles.addCatH2}>Address</h2>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <label className={styles.addCatLabel} style={{ width: '100%' }}>
                                        Street, area, city
                                        <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center' }}>{admin?.address?.city}</div>


                                    </label>

                                </div>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Country

                                        <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center' }}>{admin?.address?.country}</div>



                                    </label>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        State
                                        <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center' }}>{admin?.address?.state}</div>


                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className={styles.thumbnain}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}> Status</h2>
                            <label style={{ paddingBottom: '10px', display: "block" }}>
                                Status
                                <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center' }}>{admin?.status}</div>


                            </label>
                        </div>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>   Assign customers</h2>
                            <label style={{ paddingBottom: '10px', display: "block" }}>
                                Customers
                                {
                                    customers?.map((i) => (

                                        <div className={styles.addCatInput} style={{ display: 'flex', alignItems: 'center' }}>{i?.fullName}</div>
                                    ))
                                }


                            </label>
                        </div>
                    </div>

                </div>
            }
        </>
    );
};

export default ViewAdminForm;












{/* <div className={styles.dropdownresult}>
                                Manuafacturer name  <Closecircle />
                            </div> */}